import { useHistory } from 'react-router';
import { History } from 'history';
import * as links from 'lib/links';
import { useMemo } from 'react';

export type NavigateToHandlers = ReturnType<typeof createHandlers>;

type AnyFunction = (...args: any[]) => any;

export function useNavigateTo() {
  const history = useHistory();

  return useMemo(() => createHandlers(history), [history]);
}

function createHandlers(history: History) {
  return {
    list: handlerFactory(history, links.getBookingListPageLink),
    booking: handlerFactory(history, links.getBookingDetailsPageLink),
    cancellation: handlerFactory(history, links.getBookingCancellationQuotePageLink),
    changeDates: handlerFactory(history, links.getChangeDatesPageLink),
    changeDatesRequest: handlerFactory(history, links.getChangeDatesRequestPageLink),
    changeBooking: handlerFactory(history, links.getChangeYourBookingLink),
  };
}

function handlerFactory<T extends AnyFunction>(history: History, linkCreator: T) {
  return (action: 'push' | 'replace', ...args: Parameters<T>) => {
    const href = linkCreator(...args);

    if (action === 'push') {
      history.push(href);
    } else {
      history.replace(href);
    }
  };
}
